import styled from 'styled-components';

export const Wrapper = styled.li`
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Index = styled.div`
  width: 50px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.div`
  display: inline-flex;
  width: 100%;
  padding: 5px;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  position: relative;
`;

export const Meta = styled.span`
  color: green;
  position: absolute;
  right: 0;
`;



// WEBPACK FOOTER //
// ./src/components/LeaderboardItem/LeaderboardItemStyles.js